export const BASE_TITLE = 'My Trip Itinerary';
export const NOT_BOOKING = 'Booking not found';